//============================why work with us imports============================

import globalExpertise from "../assets/whyworkwithus/GlobalExpertise.svg";
import AdvancedTechnologyUtilization from "../assets/whyworkwithus/AdvancedTechnologyUtilization.svg";
import ClientCentricApproach from "../assets/whyworkwithus/ClientCentricApproach.svg";
import ComprehensiveTesting from "../assets/whyworkwithus/ComprehensiveTesting.svg";
import RapidSupport from "../assets/whyworkwithus/RapidSupport.svg";
import TailoredSolutionForDiverseNeed from "../assets/whyworkwithus/TailoredSolutionForDiverseNeed.svg";

export const whyWorkWithUs = [
  {
    icon: globalExpertise,
    title: "Global Expertise",
    discription: `
 Our global presence ensures that we bring
 localized knowledge and international standards to every project. 
 This extensive network allows us to understand and adapt to regional 
 nuances, providing tailored solutions that meet specific market demands. 
 Our commitment to excellence and understanding of global trends ensure 
 we deliver top-tier services, regardless of location.`,
  },
  {
    icon: ComprehensiveTesting,
    title: "Extensive Services",
    discription: `We offer a full spectrum of testing services, including
         network benchmark testing, field performance testing, 
         infotainment systems testing, HMI and tuner and media testing,
          and SOS emergency calls testing.
           Our thorough approach ensures top-quality results.`,
  },
  {
    icon: RapidSupport,
    title: "Instant Support",
    discription: `Vis Group is equipped to deploy resources quickly and
     provide ongoing support to ensure your projects stay on track
     and within budget. From initial planning to final implementation,
      we prioritize efficiency and precision. Didicated teams
       are available around the clock to address any issues, ensuring
        smooth progress and minimal downtime.`,
  },
  {
    icon: AdvancedTechnologyUtilization,
    title: "Advanced Tech Utilization",
    discription: `We leverage the latest technologies and methodologies to deliver
         efficient and reliable services. Our commitment to staying at the forefront
          of technological advancements ensures that our
           clients receive the best possible solutions`,
  },
  {
    icon: ClientCentricApproach,
    title: "Client-Centric Approach",
    discription: `Our focus is always on the client. We build strong partnerships
         and work closely with you to understand your goals, 
         providing personalized services that help you achieve success.
          Our dedicated teams are always available to assist and guide
           you through every step of the process.`,
  },

  {
    icon: TailoredSolutionForDiverseNeed,
    title: "Tailored Solutions for Diverse Needs",
    discription: `We customize our services to fit the unique requirements of each client. 
        Whether you need specialized testing, advanced software development, 
        or comprehensive quality assurance, we provide solutions
         that align with your specific goals and challenges.`,
  },
];
